// MSMEEdutainmentGamesHome.jsx
import React, { useState } from 'react';
import PixelMandala from './PixelMandala';
import Mazes from './Mazes';
import WordSearch from './WordSearch';
import LightLogicGrids from './LightLogicGrids';

const categories = [
  { 
    id: 1, 
    title: 'Pixel-Mandala', 
    desc: 'A relaxing light Nonogram puzzle to unwind and visualize patterns.', 
    component: <PixelMandala />
  },
  { 
    id: 2, 
    title: 'Mazes', 
    desc: 'Navigate through intricate paths to improve focus and mental clarity.', 
    component: <Mazes /> 
  },
  { 
    id: 3, 
    title: 'Word Search', 
    desc: 'Find hidden words to enhance attention and vocabulary in a fun way.', 
    component: <WordSearch /> 
  },
  { 
    id: 4, 
    title: 'Light 6×6 Logic Grids', 
    desc: 'Quick small-grid logic puzzles for mental clarity and stress relief.', 
    component: <LightLogicGrids /> 
  },
];

export default function MSMEEdutainmentGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  if (activeGame) {
    return (
      <div className="p-5 bg-black min-h-screen text-gray-300">
        {activeGame.component}
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen p-5 flex flex-col items-center text-gray-300">
      <h1 className="text-2xl font-bold mb-4 text-gray-300">
        😄 Relaxation + Clarity — Edutainment Zone
      </h1>

      <div className="grid gap-4 w-full max-w-5xl sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {categories.map(cat => (
          <div
            key={cat.id}
            className="flex flex-col justify-between bg-gray-900 rounded-xl p-4 shadow-md hover:shadow-lg transition"
          >
            <h3 className="text-lg font-semibold text-gray-100 mb-2">{cat.title}</h3>
            <p className="text-sm text-gray-400 flex-grow mb-4">{cat.desc}</p>

            <button
              onClick={() => setActiveGame(cat)}
              className="mt-auto px-4 py-2 rounded-lg bg-green-600 text-black font-semibold hover:bg-green-500 transition"
            >
              ▶ Play
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
